// Import the `Accordion` class from the `./accordion` module
import { Accordion } from './js/accordion';

/**
 * Check URL hash and open matching accordion if found.
 *
 * @param {AccordionGroup[]} accordionGroups Array of AccordionGroup instances.
 */
function openAccordionFromHash(accordionGroups) {
	// Get the current hash without the '#' symbol
	const hash = window.location.hash.slice(1);
	if (!hash) return;

	// Find accordion with matching hash across all groups
	for (let i = 0; i < accordionGroups.length; i++) {
		const group = accordionGroups[i];
		if (group.accordions) {
			for (let j = 0; j < group.accordions.length; j++) {
				const accordion = group.accordions[j];
				if (accordion.hash === hash) {
					// Open the accordion and scroll to it
					accordion.open(true);
					return;
				}
			}
		}
	}
}

// Define an `AccordionGroup` class
export class AccordionGroup {
	// Constructor function that takes a DOM element `el` as a parameter
	constructor(el, autoCloseSiblings = false) {
		// Check if the `el` parameter is present
		if (el) {
			// Store the `el` parameter as an instance variable
			this.el = el;

			// Query all the `.wp-block-embark-accordion` elements within `el`
			this.accordionEls = [...this.el.querySelectorAll('.wp-block-embark-accordion')];

			// If any `.wp-block-embark-accordion` elements are found
			if (this.accordionEls.length) {
				// Create a new `Accordion` object for each `.wp-block-embark-accordion` element
				this.accordions = this.accordionEls.map((el) => new Accordion({ el, group: this, autoCloseSiblings }));
			}
		}
	}
}

document.addEventListener('DOMContentLoaded', () => {
	// Query all the `.wp-block-embark-accordions` elements on the page
	const accordions = [...document.querySelectorAll('.wp-block-embark-accordions')];

	// If any `.wp-block-embark-accordions` elements are found
	if (accordions.length) {
		// Create a new `AccordionGroup` object for each `.wp-block-embark-accordions` element
		embark.components.accordions = accordions.map((el) => new AccordionGroup(el));

		// Check for URL hash and open matching accordion on initial load
		openAccordionFromHash(embark.components.accordions);

		// Listen for hash changes (e.g., when clicking links with hash)
		window.addEventListener('hashchange', () => {
			openAccordionFromHash(embark.components.accordions);
		});
	}
});
